import {
  GradientDropdown,
  GradientDropdownItem,
} from '@/components/generic/dropdown/GradientDropdown';
import {
  IroAssessmentIrremediabilityStatsFragment,
  IroAssessmentLikelihoodStatsFragment,
  IroAssessmentScaleStatsFragment,
  IroAssessmentScopeStatsFragment,
  IroAssessmentTimeHorizonStatsFragment,
} from '@/graphql/generated';

export const IroPickerDropdown = <ItemType extends GradientDropdownItem>({
  assessmentStats,
  items,
  selected,
  chooseItemId,
  readOnly,
}: {
  assessmentStats:
    | IroAssessmentScopeStatsFragment
    | IroAssessmentScaleStatsFragment
    | IroAssessmentLikelihoodStatsFragment
    | IroAssessmentIrremediabilityStatsFragment
    | IroAssessmentTimeHorizonStatsFragment
    | null;
  items: Map<string | null, ItemType>;
  selected: ItemType | null;
  chooseItemId: (itemId: string | null) => void;
  readOnly?: boolean;
}) => {
  const mostAnsweredItem = assessmentStats?.mostAnswered
    ? items.get(assessmentStats?.mostAnswered)
    : null;
  const mostAnsweredPercentage =
    assessmentStats?.distribution?.find(
      (answer) => answer.value === assessmentStats?.mostAnswered,
    )?.percentage ?? undefined;
  const answerDistribution = assessmentStats?.distribution?.reduce(
    (acc, answer) => {
      const item = items.get(answer.value);
      if (!item) {
        return acc;
      }

      acc.set(item.id, answer.percentage);
      return acc;
    },
    new Map(),
  );

  return (
    <div className="flex flex-col gap-1 items-center">
      <GradientDropdown
        {...{
          items: Array.from(items.values()),
          selected,
          chooseItemId,
          disabled: readOnly,
          distribution: answerDistribution,
        }}
      />
      {mostAnsweredItem && (
        <div className="flex gap-1 text-gray-300 items-center">
          {mostAnsweredItem.name} -
          {mostAnsweredPercentage !== undefined && (
            <span className="text-xs text-gray-300">
              ({Math.round(mostAnsweredPercentage)}%)
            </span>
          )}
        </div>
      )}
    </div>
  );
};
